var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-usable-dropdown',{class:[_vm.error ? 'error' : 'no-error'],attrs:{"nameFields":['name'],"keyField":"id","items":_vm.files},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }